define(function (require) {
    "use strict";

    var LE = require("app");
    var Template = require("personalization-user-management-templates/lpa.tmpl");
    var Button = require("ui/button/Button");
    var BaseAnchorView = require("personalization-views/BaseAnchorView");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var KpContent = require("ui.components/kpContent/kpContent");

    var LpaView = {};
    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

        LpaView = BaseAnchorView.extend({
            template: Template,
            withUIComponents: true,
            className: "lpa-anchor-view anchor hide",
            ui: {
                lpaEditButton: ".lpa-edit-button",
                currentLpaState: ".current-status-container",
                knowledgePack: ".kp",
                descriptionLabel: ".sub-title",
                lpaEditButtonContainer: ".lpa-bubble-button"
            },
            uiComponents: {
                editButton: {
                    type: Button,
                    options: {
                        el: "view.ui.lpaEditButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonClick"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.userManagement.lpa.title.learnMore"),
                        kpID: "lpa-permissions-assignment"
                    }
                }
            },

            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "LpaView:initialize", options);
                this.anchorSelector = options.anchorSelector;
                this.featureId = options.featureId;
                BaseAnchorView.prototype.initialize.call(this, options);
            },
            onRender: function (options) {
                LEPersonalization.logger.info("rendering", "LpaView:onRender", options);
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
                this.ui.descriptionLabel.text(LE.translator.translate("LEPersonalization.userManagement.lpa.description"));

            },
            onClose: function () {
                LEPersonalization.logger.debug("closing view", "LpaView:onClose");
            },
            setLpaIsAssigned: function (isLpaAssigned) {
                LEPersonalization.logger.debug("LPA assigned toggle set", "LpaView:setLpaIsAssigned", isLpaAssigned);
                var labelState = isLpaAssigned ? "enabled" : "disabled";
                this.ui.currentLpaState.text(LE.translator.translate("LEPersonalization.userManagement.lpa." + labelState + ".label"));
                this.$el.removeClass("hide");
            },
            _onEditButtonClick: function () {
                LEPersonalization.logger.debug("Edit button was clicked", "LpaView:_onEditButtonClick");
                this.trigger("lpa:navigateToFeatureEdit");
            }
        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return LpaView;
});
